/* 遵循ant-design-pro定义接口规范 */
/* https://github.com/ant-design/ant-design-pro */

import { CORE_AXIOS, type Http } from "@/core"
import { container } from "tsyringe"
import type { DictionaryArray, DictionaryCreateSingle, DictionaryEntry, DictionaryEntrySingle, DictionarySingle } from "./type/DictionaryType"

/** 获取所有字典 */
export async function dictionaryList(): Promise<DictionaryArray> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<DictionaryArray>('/v1/api/dictionaries')
}

/** 添加字典 */
export async function dictionaryAdd(data: DictionaryCreateSingle): Promise<DictionarySingle> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.post<DictionarySingle>('/v1/api/dictionaries', data)
}

/** 修改字典 */
export async function dictionaryEdit(data: DictionarySingle): Promise<DictionarySingle> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.put<DictionarySingle>('/v1/api/dictionaries/' + data.id, data)
}

/** 删除字典 */
export async function dictionaryDelete(data: DictionarySingle): Promise<DictionarySingle> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.delete<DictionarySingle>('/v1/api/dictionaries/' + data.id)
}

/** 获取相关字典下的所有条目 */
export async function dictionaryEntryList(id: string): Promise<DictionaryEntry> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<DictionaryEntry>(`/v1/api/dictionaries/${id}`)
}

/** 添加条目 */
export async function dictionaryEntryAdd(id: string, data: DictionaryEntrySingle): Promise<DictionarySingle> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.post<DictionarySingle>('/v1/api/dictionaries/' + id + '/items', data)
}
/** 修改条目 */
export async function dictionaryEntryEdit(id: string, data: DictionaryEntrySingle): Promise<DictionarySingle> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.put<DictionarySingle>('/v1/api/dictionaries/' + id + '/items/' + data.id, data)
}
/** 删除条目 */
export async function dictionaryEntryDelete(id: string, data: DictionaryEntrySingle): Promise<DictionarySingle> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.delete<DictionarySingle>('/v1/api/dictionaries/' + id + '/items/' + data.id)
}
